import React from 'react';
import styled from '@emotion/styled';
import { RTCTask } from 'core/models/rtc';
import { RTCTaskQueue } from '../RTCTaskQueue';
import { RTCInfoPanel } from '../RTCInfoPanel';

const Frame = styled.div({
    width: 'fit-content',
    height: '100%',

    background: '#101224',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
});

const Queue = styled(RTCTaskQueue)({
    height: '100%',
    marginBottom: '-36px',
    zIndex: 1,
});

const Info = styled(RTCInfoPanel)({
    flexShrink: 0,
});

export type RTCQueuePanelProps = {
    tasks: RTCTask[];
};

export function RTCQueuePanel(props: RTCQueuePanelProps) {
    const { tasks } = props;

    return (
        <Frame>
            <Queue tasks={tasks} />
            <Info task={tasks[0]} />
        </Frame>
    );
}
